export default "__VITE_ASSET__a4bde9ba__"